import { Box } from "@mui/material";
import { IUser } from "Models/User";
import { useIntl } from "react-intl";

export interface IUserStatusProps {
  user: IUser;
}

export const UserStatus = ({user}: IUserStatusProps) => {
  const { formatMessage } = useIntl();
  if (user.activationCodeSended && !user.verified) {  
    return <Box sx={{display: 'flex', alignItems: 'center'}}><Box sx={{
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#F19229",
      marginRight: '8px',
      fontSize: '0.9rem'
    }}/>{formatMessage({id:"userStatus.credentialsSent"})}</Box>
  }
  if (user.verified) {  
    return <Box sx={{display: 'flex', alignItems: 'center'}}><Box sx={{
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#27939D",
      marginRight: '8px',
      fontSize: '0.9rem'
    }}/>{formatMessage({id:"userStatus.accountActive"})}</Box>
  }
  return <Box sx={{display: 'flex', alignItems: 'center'}}><Box sx={{
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: "#8D004C",
    marginRight: '8px'
  }}/>{formatMessage({id:"userStatus.credentialsPendingDelivery"})}</Box>
}
